import { instance } from '../index';
import { default as httpInstance } from '@/jmHttp/index';
import { scheduleManage } from '@/jmHttp/interface';

// 日程列表查询
export const myScheduleList = async (data, config = {}) => {
  return await instance.post('/api/admin/schedule/management/list', data, config);
};
// 获取进门账号登录参数
export const getJmParams = async (data, config = {}) => {
  return await instance.get('/api/admin/user/mainLine/getTokenByUid', data, config);
};

export const insert = async (data, config = {}) => {
  return await instance.post('/api/admin/convention/helpmeet/insert', data, config);
};

export const update = async (data, config = {}) => {
  return await instance.post('/api/admin/convention/helpmeet/update', data, config);
};

export const myScheduleDetail = async (data, config = {}) => {
  return await instance.get(`/api/admin/mySchedule/${data.id}`, data, config);
};

// 溯源
export const querySummaryPointsTrace = async (data) => {
  return await instance.get('/api/admin/meetingSummary/querySummaryPointsTrace', data);
};

// 获取会议信息
export const selectSummaryBySourceId = async (data, config) => {
  return await instance.get('/api/admin/summary/selectSummaryBySourceId', data, config);
};

// 导入日程
export const importScheduleAction = async (data) => {
  return await instance.post('/api/admin/schedule/add', data);
};

// 编辑导入日程
export const importScheduleUpdateAction = async (data) => {
  return await instance.post('/api/admin/schedule/edit', data);
};

// 导入日程列表
export const importScheduleListAction = async (data) => {
  return await instance.post('/api/admin/schedule/list', data);
};

// 获取导入日程详情
export const getImportScheduleDetail = async (id) => {
  return await instance.get(`/api/admin/schedule/details/${id}`);
};

// 删除导入日程
export const deleteImportSchedule = async (id) => {
  return await instance.delete(`/api/admin/schedule/delete/${id}`);
};

// 校验是否已经存在用户申请记录
export const existsPlaybackRecord = async (data) => {
  return await instance.post('/api/admin/schedule/management/existsPlaybackRecord', data);
};

// 获取可选的销售列表
export const queryOrgPartnerSalesList = async (data) => {
  return await instance.get('/api/admin/orgPartner/list-user-org-partner-sales', data);
};

// 申请回放-查看回放
export const addSchedulePlaybackRecord = async (data) => {
  return await instance.post('/api/admin/schedule/management/addSchedulePlaybackRecord', data);
};

// 根据日期获取每一天的日程数量
export const getScheduleCountByDate = async (data) => {
  return await instance.post('/api/admin/schedule/management/date-count', data);
};

// 纪要详情页面导出数据按钮
export const exportAIIndicatorList = async (data) => {
  return await instance.get('/api/admin/summary/exportAIIndicatorList', data, {
    responseType: 'blob'
  });
};

// 增加浏览记录
export const addUserBrowse = async (data, config = {}) => {
  return await instance.post('/api/admin/common/add-user-browse', data, config);
};
// 按天查询日程数量
export const scheduleCountByDay = async (data) => {
  return await instance.post('/api/admin/roadshow/list-by-day', data);
};

// 路演详情
export const roadshowDetail = async (id) => {
  return await instance.get(`/api/admin/roadshow/detail/${id}`);
};

// 路演 收藏
export const roadshowCollect = async (data) => {
  return await instance.post('/api/admin/roadshow/roadshow-collection', data);
};

// 路演 取消收藏
export const roadshowCancelCollect = async (data) => {
  return await instance.post('/api/admin/roadshow/cancel-roadshow-collection', data);
};

// 路演 标记重要
export const roadshowMarkImportant = async (data) => {
  return await instance.post('/api/admin/schedule/management/sign-important', data);
};

// 路演 取消标记重要
export const roadshowCancelMarkImportant = async (data) => {
  return await instance.post('/api/admin/schedule/management/cancel-sign-important', data);
};

export const isMarkImportant = async (data) => {
  return await instance.post('/api/admin/schedule/management/judge-sign-important', data);
};

// 添加路演观看历史
export const roadshowWatchRecord = async (data) => {
  return await instance.post('/api/admin/roadshow/watch-record', data);
};

// 获取近一周是否有直播日程
export const getLiveSchedule = async (data) => {
  return await instance.post('/api/admin/schedule/management/user-schedule-living-road-show', data);
};

// 获取自动预约状态
export const getAutoBookingStatus = async () => {
  return httpInstance.get(scheduleManage.getAutoBookingStatus);
};

// 设置自动预约状态
export const setAutoBookingStatus = async (data, options) => {
  return httpInstance.post(scheduleManage.setAutoBookingStatus, data, options);
};
